import { render, staticRenderFns } from "./AiMessage.vue?vue&type=template&id=15a61564&"
import script from "./AiMessage.vue?vue&type=script&lang=js&"
export * from "./AiMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports